module.exports = __webpack_public_path__ + "media/images/map_icons/Swimming-c821296cb73d5d7c86e93d8695ec7f3b.svg";